import { Schema } from 'normalizr';

const snippetSchema = function(name) {
  return new Schema(name, {
    idAttribute: (entity) => entity.id ? entity.id : entity.canonical_name
  });
};

export default snippetSchema;